export const BLOG_CATALOG = [{
  showInFooter: false,
  path: '/virtual-holiday-party-agenda',
  title: 'A 45-minute virtual holiday party agenda'
}, {
  showInFooter: false,
  path: '/remote-team-halloween-games',
  title: 'Remote team Halloween games: a relaxed 30-minute plan'
}, {
  showInFooter: false,
  path: '/weekly-team-game-rotation',
  title: 'A four-week team game rotation'
}, {
  showInFooter: false,
  path: '/online-team-games-for-10-people',
  title: 'Online team games for 10 people'
}, {
  showInFooter: false,
  path: '/online-team-games-for-4-people',
  title: 'Online team games for 4 people'
}, {
  showInFooter: false,
  path: '/15-minute-team-trivia',
  title: 'How to run a 15-minute team trivia break'
}, {
  showInFooter: false,
  path: '/15-minute-online-drawing-game',
  title: 'A 15-minute online drawing game for small teams'
}, {
  showInFooter: false,
  path: '/online-team-game-20-people',
  title: 'An online team game for 20 people'
}, {
  path: '/team-drawing-games',
  title: 'Team Drawing Games'
}, {
  path: '/virtual-icebreaker-games',
  title: 'Virtual Icebreaker Games'
}, {
  showInFooter: false,
  path: '/choices-with-introductions',
  title: 'Choices with introductions: a printable team activity'
}];
export default BLOG_CATALOG;